import PropTypes from "prop-types";
import { Suspense } from "react";
import { matchPath } from "react-router-dom";
import { PageLoader } from "@repo/design-system/components/ui";


const PublicRoute = ({ children }) => (
  <Suspense fallback={<PageLoader />}>
    {children}
  </Suspense>
);

PublicRoute.propTypes = {
  children: PropTypes.node.isRequired,
};


export const isPublicPath = (pathname, publicRoutes = []) =>
  publicRoutes.some((route) => Boolean(matchPath(route.path, pathname)));

export default PublicRoute;
